/**
 * @generated SignedSource<<f85974714fd8a7e2152e75cc70b3f7d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingKindEnum = "agm" | "commitee" | "other" | "%future added value";
export type MeetingUpdateInput = {
  clientMutationId?: string | null | undefined;
  meeting: MeetingUpdateInputObject;
};
export type MeetingUpdateInputObject = {
  date?: any | null | undefined;
  description?: string | null | undefined;
  id: string;
  kind?: MeetingKindEnum | null | undefined;
  link?: string | null | undefined;
  locked?: boolean | null | undefined;
  name?: string | null | undefined;
};
export type UpdateMeetingForm_Mutation$variables = {
  input: MeetingUpdateInput;
};
export type UpdateMeetingForm_Mutation$data = {
  readonly updateMeeting: {
    readonly meeting: {
      readonly date: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly kind: MeetingKindEnum | null | undefined;
      readonly link: string | null | undefined;
      readonly name: string | null | undefined;
    };
  };
};
export type UpdateMeetingForm_Mutation = {
  response: UpdateMeetingForm_Mutation$data;
  variables: UpdateMeetingForm_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MeetingUpdatePayload",
    "kind": "LinkedField",
    "name": "updateMeeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Meeting",
        "kind": "LinkedField",
        "name": "meeting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateMeetingForm_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateMeetingForm_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc0d5c66b5d54acd9cb68d037f1c3936",
    "id": null,
    "metadata": {},
    "name": "UpdateMeetingForm_Mutation",
    "operationKind": "mutation",
    "text": "mutation UpdateMeetingForm_Mutation(\n  $input: MeetingUpdateInput!\n) {\n  updateMeeting(input: $input) {\n    meeting {\n      id\n      name\n      link\n      description\n      date\n      kind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "392b0c5999b5c3f4e42377ec59ada5c5";

export default node;
